import type { Router } from 'next/router'
import { getOrderedParamKeys } from '../getOrderedParamKeys/getOrderedParamKeys'

export const getRecursiveDialogParamAsLocation = (asPath: Router['asPath']) => {
  const recursiveDialogParamKeys = getOrderedParamKeys(asPath, [
    'bill_id',
    'invoice_id',
    'receipt_id',
    'receivable_id',
    'purchase_order_id',
  ])

  const topLevelParam = recursiveDialogParamKeys[recursiveDialogParamKeys.length - 1]

  // Support both bill_id (new) and invoice_id (legacy) for backwards compatibility
  if (topLevelParam === 'bill_id' || topLevelParam === 'invoice_id') {
    return 'bill-details-dialog' as const
  }

  if (topLevelParam === 'receivable_id') {
    return 'invoice-details-dialog' as const
  }

  if (topLevelParam === 'receipt_id') {
    return 'shipping-receipt-details-dialog' as const
  }

  if (topLevelParam === 'purchase_order_id') {
    return 'purchase-order-details-dialog' as const
  }

  return null
}
